import React, { useState } from "react";
import API from "../../../../utils/API";
import { Spinner } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { Card, CardBody, CardText, UncontrolledCollapse } from "reactstrap";
import TestLead from "./TestLead";

const AiEditor = ({orderId}) => {
    const [prompt,setPrompt] = useState(null);
    const [result,setResult] = useState(null);
    const [loading,setLoading] = useState(false);

    const [pushing,setPushing] = useState(false);

    const [resultContent,setResultContent] = useState(null);
    const [resultAnalyze,setResultAnalyze] = useState(null);

    const [requestId, setRequestId] = useState(null);

    const [pushed, setPushed] = useState(false);
    const [pushResult, setPushResult] = useState(null);

    const generate = () => {
        setLoading(true);
        setResultContent(null);
        setResultAnalyze(null);
        API.post('/ai/integration/edit',{lenderOrder: orderId,prompt: prompt}).then((response)=>{
            setResult(response.data.data);
            setLoading(false);

            setResultContent(response?.data?.data?.content?.diff);
            setResultAnalyze(response?.data?.data?.analyze?.diff);
            setRequestId(response?.data?.data?.aiResultId);
        }).catch(()=>{
            setLoading(false);
        })
    }

    const push = () => {
        setPushing(true);
        API.post('/ai/integration/push',{lenderOrder: orderId,request: requestId, prompt: prompt}).then((response)=>{
            setPushResult(response.data.data);
            setPushing(false);

            if (response.data.data.status === 'ok') {
                setPushed(true);
            }else {
                toastr.error('Error', response.data.data.message);
            }
        }).catch(()=>{
            setPushing(false);
        })
    }

    return <div>
        {pushed ?
            <>
                <div className="p-3" role="alert"><h5>Your changes have been submitted and are currently awaiting approval from the development team. You will be notified once the changes are approved and deployed live.</h5></div>
            </>
            :
            <>
                <label>Description of Changes</label>
                <textarea className="form-control" disabled={loading || pushing} rows="7" style={{width:"100%"}} onChange={(e)=>setPrompt(e.target.value)}/>
                <div className="text-center mt-3">
                    {requestId && <button className="btn btn-success mr-2" type='button' disabled={pushing} onClick={push}>{pushing && <Spinner size={"sm"}/>} Accept</button>}
                    {!pushing && <button className="btn btn-primary" type='button' disabled={loading || (!prompt || prompt.length < 5)} onClick={generate}>{loading && <Spinner size={"sm"}/>} Generate</button>}
                </div>
                {requestId &&
                    <div className="mt-2">
                        {resultContent &&
                            <Card className={'mb-0'}>
                                <div
                                    className={'bg-success p-1'}
                                >
                                    <a
                                        id={"collapseContent"}
                                        className="text-white"
                                        href={"#collapseContent"}
                                    >
                                        Data
                                    </a>
                                </div>
                                <UncontrolledCollapse toggler={"#collapseContent"}>
                                    <CardBody>
                                        <CardText>
                                            <div dangerouslySetInnerHTML={{ __html: resultContent }}/>
                                        </CardText>
                                    </CardBody>
                                </UncontrolledCollapse>
                            </Card>
                        }
                        {resultAnalyze &&
                            <Card className={'mb-0'}>
                                <div
                                    className={'bg-success p-1'}
                                >
                                    <a
                                        id={"collapseResult"}
                                        className="text-white"
                                        href={"#collapseResult"}
                                    >
                                        Result
                                    </a>
                                </div>
                                <UncontrolledCollapse toggler={"#collapseResult"}>
                                    <CardBody>
                                        <CardText>
                                            <div dangerouslySetInnerHTML={{ __html: resultAnalyze }}/>
                                        </CardText>
                                    </CardBody>
                                </UncontrolledCollapse>
                            </Card>
                        }
                        <Card className={'mb-0'}>
                            <div
                                className={'bg-primary p-1'}
                            >
                                <a
                                    id={"collapseTest"}
                                    className="text-white"
                                    href={"#collapseTest"}
                                >
                                    Send test
                                </a>
                            </div>
                            <UncontrolledCollapse toggler={"#collapseTest"}>
                                <CardBody>
                                    <CardText>
                                        <TestLead orderId={orderId} contentSource={result.content.new} resultSource={result.analyze.new}/>
                                    </CardText>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card>
                    </div>
                }
            </>
        }
    </div>
}

export default AiEditor;
